/**
* WeightAgeFormController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';WeightAgeFormController.$inject = ["$scope", "$rootScope", "$localStorage", "$state", "$stateParams", "gplansConf", "mesSystem", "ValidateBmi"];

  angular.
  module('gplans.survey.controllers').
  controller('WeightAgeFormController', WeightAgeFormController);

  WeightAgeFormController.$inject = ['$scope', '$rootScope', '$localStorage', '$state', '$stateParams', 'gplansConf',
  'mesSystem', 'ValidateBmi'];

  /**
                               * @namespace WeightAgeFormController
                               */
  function WeightAgeFormController($scope, $rootScope, $localStorage, $state, $stateParams, gplansConf, mesSystem,
  ValidateBmi) {
    var vm = this;
    vm.dataChanged = dataChanged;
    vm.mesSystem = mesSystem;
    vm.changeBmi = changeBmi;
    vm.changeHeight = changeHeight;
    vm.height = null;
    var maxHeight, minHeight;
    activate();

    /**
                * @name activate
                * @desc Actions to be performed when this controller is instantiated
                * @memberOf gplans.survey.controllers.QuestionController
                */
    function activate() {
      // null required for input to show placeholders
      if (vm.mesSystem == 'SI') {
        vm.weightUnit = 'kg';
        vm.heightUnit = 'cm';
        maxHeight = 250;
        minHeight = 125;
      } else
      {
        vm.weightUnit = 'lbs';
        vm.heightUnit = 'inches';
        maxHeight = 100;
        minHeight = 50;
      }

      vm.current_weight = Number(window.gplansStorage.getItem('current_weight')) || null;
      vm.goal_weight = Number(window.gplansStorage.getItem('goal_weight')) || null;
      vm.age = Number(window.gplansStorage.getItem('age')) || null;
      vm.gender = window.gplansStorage.getItem('gender');
      vm.height = Number(window.gplansStorage.getItem('height')) || null;
      vm.height_feet = null;
    }

    vm.finishSurvey = function () {
      if (!changeBmi() && !changeHeight()) {
        $('input').not('#id_height, #id_height_inches').each(function () {
          var name = $(this).attr('name');
          var value = $(this).val();
          window.gplansStorage.setItem(name, value);
        });
        var gender = $('select[name=gender]')[0].value;
        window.gplansStorage.setItem('gender', gender);
        _sendGenderToFB(gender);
        window.gplansStorage.setItem('height', calculateHeight());
        $state.go('base.calculate', { userSurvey: $scope.$parent.usersurvey.id });
      }
    };

    function dataChanged() {
      $rootScope.quizChanged = true;
    }

    function changeBmi() {
      var height = calculateHeight();
      var weight = angular.copy(vm.goal_weight);
      var gender = vm.gender;
      var recommendedWeight = ValidateBmi.validate(height, weight, vm.mesSystem, gender);
      if (recommendedWeight !== null) {
        vm.goal_weight = recommendedWeight;
      }
      return recommendedWeight;
    }

    function calculateHeight() {
      if (vm.mesSystem == 'US') {
        var feet = vm.height_feet;
        var inches = vm.height;
        if (!feet) feet = 0;
        if (!inches) inches = 0;
        var height = parseInt(feet) * 12 + parseInt(inches);
        return height;
      } else
      return vm.height_feet;
    }

    function changeHeight() {
      var height = calculateHeight();
      if (vm.mesSystem == 'US') {
        if (height > maxHeight) {
          var maxHeightFeet = Math.floor(maxHeight / 12);
          var maxHeightInches = maxHeight % 12;
          alert('Max height is ' + maxHeightFeet + ' feet, ' + maxHeightInches + ' inches');
          vm.height_feet = maxHeightFeet;
          vm.height = maxHeightInches;
          return 1;
        } else
        if (height < minHeight) {
          var minHeightFeet = Math.floor(minHeight / 12);
          var minHeightInches = minHeight % 12;
          alert('Min height is ' + minHeightFeet + ' feet, ' + minHeightInches + ' inches');
          vm.height_feet = minHeightFeet;
          vm.height = minHeightInches;
          return 1;
        }
      } else
      {
        if (height > maxHeight) {
          alert('Max height is ' + maxHeight + ' cm');
          vm.height_feet = maxHeight;
          return 1;
        } else
        if (height < minHeight) {
          alert('Min height is ' + minHeight + ' cm');
          vm.height_feet = minHeight;
          return 1;
        }
      }
      return 0;
    }

    function _sendGenderToFB(gender) {
      if (window.fbq && gender) {
        fbq('track', 'PageView', {
          gender: gender });

      }
    }
  }
})();